import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'percentageBasedBg',
})
export class PercentageBasedBgPipe implements PipeTransform {
  transform(value: any, top: number, bottom: number): string {
    if (
      top == null ||
      top == undefined ||
      bottom == null ||
      bottom == undefined
    ) {
      return '';
    }
    const percent = (top / bottom) * 100;

    if (percent >= 80) {
      return 'background: #05A505 !important';
    }
    if (percent >= 60) {
      return 'background: #AAAA04 !important';
    }
    if (percent >= 40) {
      return 'background: #FFBF00 !important';
    }
    if (percent >= 20) {
      return 'background: #AD7100 !important';
    }
    return 'background: #E60707 !important';
  }
}
